import _classCallCheck from "@babel/runtime/helpers/classCallCheck";
import _createClass from "@babel/runtime/helpers/createClass";
import _inherits from "@babel/runtime/helpers/inherits";
import _possibleConstructorReturn from "@babel/runtime/helpers/possibleConstructorReturn";
import _getPrototypeOf from "@babel/runtime/helpers/getPrototypeOf";

var _dec, _class;

function _createSuper(Derived) { var hasNativeReflectConstruct = _isNativeReflectConstruct(); return function _createSuperInternal() { var Super = _getPrototypeOf(Derived), result; if (hasNativeReflectConstruct) { var NewTarget = _getPrototypeOf(this).constructor; result = Reflect.construct(Super, arguments, NewTarget); } else { result = Super.apply(this, arguments); } return _possibleConstructorReturn(this, result); }; }

function _isNativeReflectConstruct() { if (typeof Reflect === "undefined" || !Reflect.construct) return false; if (Reflect.construct.sham) return false; if (typeof Proxy === "function") return true; try { Boolean.prototype.valueOf.call(Reflect.construct(Boolean, [], function () {})); return true; } catch (e) { return false; } }

import React, { Component } from 'react';
import { connect } from 'react-redux';
import { PostPlatformPreview } from 'components';
import moment from 'moment';
import { orgInitialState } from 'redux/modules/composeboxForm';
import gmbLogo from '../../assets/google-my-business-logo.svg';
import igLogo from '../../assets/instagram-logo.svg';
import fbLogo from '../../assets/facebook-logo.svg';
import liLogo from '../../assets/linkedin-icon.svg';
import * as styles from './Composebox.scss';
var ComposeboxPreview = (_dec = connect(function (state) {
  var orgId = state.organization.current.id;
  return {
    config: state.config,
    composeboxForm: state.composeboxForm["".concat(orgId)] || orgInitialState,
    organization: state.organization.current,
    organizationId: state.organization.current.id,
    user: state.auth.user
  };
}, {}), _dec(_class = /*#__PURE__*/function (_Component) {
  _inherits(ComposeboxPreview, _Component);

  var _super = _createSuper(ComposeboxPreview);

  function ComposeboxPreview() {
    _classCallCheck(this, ComposeboxPreview);

    return _super.apply(this, arguments);
  }

  _createClass(ComposeboxPreview, [{
    key: "render",
    value:
    /** *********************************************************
     RENDER
     ***********************************************************/
    function render() {
      var composeboxForm = this.props.composeboxForm;
      var videos = composeboxForm.videoUrl && composeboxForm.postType === 'videoPost' ? [composeboxForm.videoUrl] : [];
      var boostPost = composeboxForm && composeboxForm.fromPlannedAd && composeboxForm.fromPlannedAd.name;
      var topAmount = boostPost ? 65 : 12; // if it is a draft post and has a date, use that date in the preview:

      var useDraft = composeboxForm && composeboxForm.DraftPost && composeboxForm.DraftPost.suggestedPublishAt;
      var origPostDate = composeboxForm.publishAt ? moment(composeboxForm.publishAt) : null;
      var postDate = useDraft ? moment(composeboxForm.DraftPost.suggestedPublishAt) : origPostDate; // 

      return /*#__PURE__*/React.createElement("div", {
        style: {
          position: 'absolute',
          top: topAmount
        }
      }, boostPost && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.postDateTime
      }, "This post will be boosted with an ad, so it must adhere to", ' ', /*#__PURE__*/React.createElement("a", {
        href: "https://www.facebook.com/policies/ads/",
        target: "_blank"
      }, "Facebook's Ad Guidelines"), ".")), /*#__PURE__*/React.createElement("div", {
        style: {
          maxWidth: 527,
          width: '100%'
        }
      }, /*#__PURE__*/React.createElement("div", {
        style: {
          marginTop: 10
        }
      }, /*#__PURE__*/React.createElement("div", null, this.props.composeboxForm.selectedPreviewTab === 'LinkedIn' && this.props.composeboxForm.images && this.props.composeboxForm.images.length > 1 && /*#__PURE__*/React.createElement("div", {
        style: {
          marginBottom: 24
        }
      }, /*#__PURE__*/React.createElement("span", {
        className: styles.postDateTime
      }, /*#__PURE__*/React.createElement("i", null, "LinkedIn does not currently support multi-image posts."))), /*#__PURE__*/React.createElement(PostPlatformPreview, {
        images: composeboxForm.postType === 'linkPost' && composeboxForm.linkData.image ? [composeboxForm.linkData.image] : composeboxForm.images,
        videos: videos,
        messages: composeboxForm.messages,
        link: composeboxForm.postType === 'linkPost' ? composeboxForm.linkData.link : null,
        linkTitle: composeboxForm.linkData.title,
        linkDescription: composeboxForm.linkData.description,
        linkCaption: composeboxForm.linkData.caption,
        postType: composeboxForm.postType,
        postDate: postDate,
        style: {
          marginTop: 20
        }
      })))));
    }
  }]);

  return ComposeboxPreview;
}(Component)) || _class);
export { ComposeboxPreview as default };